<template>
    <CContainer>
        <CRow v-if="$policy('store').join">
            <CCol col="12" class="px-0">
                <CCard>
                    <CCardBody>
                        <p class="mb-0">
                            تمامی پرداختی‌ها
                            <span
                                class="font-weight-bold font-lg text-success"
                            >20ام</span> هر ماه به صورت خودکار به شماره شبای شما واریز خواهد شد.
                        </p>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>

        <CRow>
            <CCol col="3" class="d-flex overflow-auto px-0">
                <CCard class="px-3 py-2 w-100">
                    <p class="font-lg text-primary">{{ $t('transaction.account_balance') }}({{ $t('rial') }})</p>
                    <p
                        class="text-center font-xl font-weight-bold mb-3"
                    >{{ $numberWithCommas(user.balance.toLocaleString()) }}</p>
                </CCard>
            </CCol>
            <CCol v-if="$policy('store').join" col="3" class="d-flex overflow-auto px-0 mr-2">
                <CCard class="px-3 py-2 w-100">
                    <p class="font-lg text-primary">{{ $t('transaction.removeable_balance') }}({{ $t('rial') }})</p>
                    <p
                        class="text-center font-xl font-weight-bold mb-3"
                    >{{ user.removeable_balance ? $numberWithCommas(user.removeable_balance.toLocaleString()) : 0 }}</p>
                </CCard>
            </CCol>
            <CCol col="3" class="d-flex overflow-auto px-0 mr-2">
                <CCard class="px-3 py-2 w-100">
                    <p class="font-lg text-primary">{{ $policy('store').join ? $t('transaction.total_income') : $t('transaction.total_paid_money') }}({{ $t('rial') }})</p>
                    <p
                        class="text-center font-xl font-weight-bold mb-3"
                    >{{ $numberWithCommas(user.total_paid_money.toLocaleString()) }}</p>
                </CCard>
            </CCol>
        </CRow>

        <CRow>
            <CCol col="12" class="d-flex overflow-auto px-0">
                <FilterIt />
                <SortIt class="mr-auto" />
            </CCol>
        </CRow>

        <Table class="mt-2" />
    </CContainer>
</template>

<script>
import { mapGetters } from 'vuex'
import { Table, FilterIt, SortIt } from './partials'

export default {
    name: 'List',

    components: {
        Table,
        FilterIt,
        SortIt,
    },

    computed: {
        ...mapGetters({
            current: 'user/current'
        }),
        user() {
            return this.current
        }
    },
}
</script>
